import { EventAggregator } from "aurelia-event-aggregator";
import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { Router } from "aurelia-router";
import { TableHeader } from "components/table/table-content";
import { Filters, filterTypes } from "elements/Filter";
import { PubSub } from "lib/event/PubSub";
import { FilterManager } from "lib/tables/FilterManager";
import { ErpSystem } from "models/ErpSystem";
import { ErpSystemService } from "services/erp-system-service";
import { ErrorService } from "services/error-service";
import { SewingThreadTypeServiceService } from "services/sewing-thread-type-service-service";

type SewingThreadTypeService = {
  Id: number;
  Name: string;
  ArticleNo: string;
  ErpSystemName: string;
};

@autoinject
export class SewingThreadTypeServiceList {
  protected tableData: Array<SewingThreadTypeService>;
  protected activeTableRow: number;

  protected erpSystems: ErpSystem[] = [];

  protected tableHeaders: TableHeader<SewingThreadTypeService>[] = [
    { key: 'Name', label: 'general.name', sortable: true },
    { key: 'ArticleNo', label: 'general.articleno', sortable: true },
    { key: 'ErpSystemName', label: 'general.erpSystem', sortable: false },
  ];

  constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private sewingThreadTypeServiceService: SewingThreadTypeServiceService,
    protected erpSystemService: ErpSystemService,
    private t: I18N,
    protected fm: FilterManager,
    private pubsub: PubSub  
  ) {
    pubsub.sub('filter-manager:filter-changed', () => {
      this.updateView();
    });
  }

  protected activate(params: { Id: number }) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  protected async attached() {
    this.eventAggregator.subscribe('sewingThreadTypeServiceListReset', () => {
      this.activeTableRow = null;
      return this.updateView();
    });

    await this.load();

    this.fm.init({
      context: 'sewing-thread-type-service',
      storageKey: 'sewing-thread-type-service',
      filters: {
        erpIds: {
          name: 'erpIds',
          label: this.t.tr('general.erpSystem'),
          type: filterTypes.CHECKBOX,
          options: this.erpSystems,
          query: 'erpIds',
        },
      } satisfies Filters,
      defaultFilters: {
        erpIds: true,
      },
    });

    this.updateView();
  }

  private async load() {
    const erpSystems = await this.erpSystemService.getAll();
    const newList = erpSystems.map((e) => {
      const newItem = { ...e, Name: e.Title };
      delete newItem.Title;
      return newItem;
    });

    this.erpSystems = newList;
  }

  private async updateView() {
    try {
      const response = await this.sewingThreadTypeServiceService.getSewingThreadTypeServiceList(this.fm.queryFilter);

      if (!response) return;
      this.fm.paginationTotalRecords = +response.headers.get('x-total-count') || 0;

      this.tableData = response.data;
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected setOrderByColumn(column: string) {
    this.fm.setOrderByColumn(column);
  }

  protected gotoDetailView(id: number) {
    this.activeTableRow = id;
    this.router.navigateToRoute('sewing-thread-type-service-detail', { Id: id });
  }

  protected detached() {
    this.pubsub.unsub();
  }

  protected unbind() {
    this.pubsub.unsub();
  }
  
}
